import NewsSubscriptionForm from './news-subscription-form';

export default NewsSubscriptionForm;
